import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react"

function ContactInfo() {
  const contactInfo = [
    {
      icon: Phone,
      title: "Telefon",
      details: ["0533 428 70 27"],
    },
    {
      icon: Mail,
      title: "E-posta",
      details: ["ramazanbasol74@gmail.com"],
    },
    {
      icon: MapPin,
      title: "Adres",
      details: ["Şirinevler Mahalesi Bestekar Sokak No-20 Karabük/Merkez"],
    },
    {
      icon: Clock,
      title: "Çalışma Saatleri",
      details: ["Her gün: 09:00 - 21:00"],
    },
  ]

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Bize Ulaşın</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Buğra Teknik Servis olarak Karabük ve ilçelerinde teknik servis hizmetleriniz için bizimle iletişime geçin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="mx-auto bg-blue-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <info.icon className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">{info.title}</h3>
                {info.details.map((detail, idx) => (
                  <p key={idx} className="text-gray-600 text-sm">
                    {detail}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center space-y-6">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/iletisim"
              className="inline-flex items-center justify-center px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-200"
            >
              İletişim Formu
            </a>
            
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactInfo
